import Tone from 'tone';
const TIME_16N = new Tone.Time('16n');
const TIME_32N = new Tone.Time('16n');

class Instrument {
    constructor() {
        this.offset = 0;
        this.parameters = [];
        this.initialBulkValues = {};
    }

    registerParameter(parameter, signalGetter) {
        let context = this.context.forInstrument(this);
        this.initialBulkValues = {
            ... this.initialBulkValues,
            ...parameter.setStore(this.store)
        };
        parameter.setMixSession(this.mixSession);
        parameter.setContext(context);
        parameter.setTrack(this.context.track);
        this.parameters.push(parameter);
    }

    getSubDevices() {
        return [];
    }
    
    getSubDeviceIndex(subDevice) {
        let subDevices = this.getSubDevices().map(s => s.value);
        return subDevices.indexOf(subDevice);
    }

    getSubDevice(index) {
        let s = this.getSubDevices().map(s => s.value)[index];
        return s;
    }

    getName() {
        return '';
    }

    get name() {
        return this.getName();
    }

    connect(node) {
        if (node !== undefined) {
            this.getInstrument().connect(node);
            this.node = node;
        }
    }

    // connects the synth from the given audio node (i.e. the mix)
    disconnect(node) {
        this.getInstrument().disconnect(node);
        this.node = undefined;
    }

    dispose() {
        this.disconnect();
        this.parameters.forEach(s => s.dispose());
    }

    isMonophonic() {
        return false;
    }

    getEnvelope() {}

    getInstrument() {}

    getInstrumentType() {}

    releaseAll() {}

    getJson() {
        return {
            instrumentType: this.getInstrumentType(),
        };
    }

    hasLFO() { return false; }

    release(transpose) {
        transpose = transpose !== undefined ? transpose : this.lastNote;
        if (this.isMonophonic() &&
            this.lastNote !== transpose) {
            return;
        }

        if (this.lastNote === undefined) {
            return;
        }
        this.getInstrument().triggerRelease([transpose]);
    }

    trigger(stepData, time, isLive=false) {
        let start = stepData.start;
        // to be extended
        var dur = null;
        if (!stepData.duration) {
        } else if (typeof stepData.duration === "number") {
            dur = TIME_16N * stepData.duration;
        } else {
            dur = new Tone.Time(stepData.duration);
        }

        let transpose = isNaN(stepData.transpose) ? 0 : stepData.transpose;
        var note = this.getNoteFromTranspose(transpose);
        var velocity = stepData.velocity === null ? 1 : stepData.velocity;
        var chops = stepData.chop == null ? 1 : stepData.chop;
        var chopDur = dur == null ? TIME_16N : dur;
        var chopRate = chopDur / (chops.toString());

        // offset the time by offset

        time = time || undefined;
        if (this.offset > 0) {
            if (time === undefined) {
                time = Tone.Master.context.currentTime;
            }
            time = (TIME_32N * this.offset) + time;
        }
        var chopTime = 
            time; //undefined; //new Tone.Time(time);

        if (this.lastSlideTranspose !== undefined || this.hasSlide) {
            this.releaseSlide(time);
        }

        if (dur && stepData.slide) {
            this.triggerSlide(note, time, dur);
            return;
        } else if (this.lastSlideTranspose !== undefined) {
            // do a fake slide where the env goes from 0 -> 0
            // but only if we had a slide since the last real trigger
            this.triggerSlide(note, time, dur, false);
            this.hasSlide = true;
        }

        if (time) {
            let detune = this.detuneParameter.get(true);
            this.detuneSignal.setValueAtTime(detune, Math.max(0, time-0.001));
        } 

        this.lastSlideTranspose = undefined;
        this.lastSlideMax = undefined;

        // this.setEnvelopes(stepData);

        let instrument = this.getInstrument();
        let gated = this.track ? this.track.gated : true;
        // trigger the instrument, once for each chop

        if (dur === Infinity) {
            dur = null;
        }

        for (var j=0; j < chops; j++) {
            this.lastNote = note;
            if (dur === null || !gated) {
                // todo: if rolling then ensure that dur is less than the resolution
                instrument.triggerAttack(
                    note, chopTime, velocity, start, stepData);
            } else {
                instrument.triggerAttackRelease(
                    note, dur, chopTime, velocity, start, stepData);
            }

            if (!chopTime) {
                chopTime = Tone.Master.context.currentTime;
            }
            chopTime = chopTime + chopRate;
        }
        this.lastTranspose = note;
    }

    hasNotes() {
        return true;
    }

    setEnvelopes(stepData) {
        let envelopes = this.getEnvelopes();
        
        // set the attack and release of this trigger
        envelopes.forEach(
            envelope =>
                envelope.attack = new Tone.Time((1 + stepData.attack) / 1000.0));
        envelopes.forEach(
            envelope =>
                envelope.release = new Tone.Time((1 + stepData.release) / 1000.0));
    }

    getNoteFromTranspose(transpose) {
        return transpose + this.sequencerEngine.transpose;
    }

    getDefaultNote() {
        return Tone.Frequency("C3");
    }

    getParameters() {
        return this.parameters;
    }

    getEnvelopes() {
        return [];
    }

    findParameter(automationJson, name) {
        let parametersFound = this.getParameters().filter(p => name === p.name);
        if (parametersFound.length === 0) {
            return 0;
        }
        return parametersFound[0];
    }

    freeze() {}
}

export default Instrument;
